module.exports = __webpack_public_path__ + "img/3f_r_cavallo.6ddfeaae.jpg";